/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_VendorDesignationDto } from '../models/PagedResultDto_VendorDesignationDto';
import type { Wealthlane_CustomerService_Dtos_VendorDesignation_CreateUpdateVendorDesignationDto } from '../models/Wealthlane_CustomerService_Dtos_VendorDesignation_CreateUpdateVendorDesignationDto';
import type { Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto } from '../models/Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VendorDesignationService {

    /**
     * @returns Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppVendorDesignationVendorDesignations(): CancelablePromise<Array<Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/vendor-designation/vendor-designations',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppVendorDesignation(
        requestBody?: Wealthlane_CustomerService_Dtos_VendorDesignation_CreateUpdateVendorDesignationDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/vendor-designation',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_VendorDesignationDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppVendorDesignation(
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_VendorDesignationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/vendor-designation',
            query: {
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto OK
     * @throws ApiError
     */
    public static putApiCustomerApiAppVendorDesignation(
        id: string,
        requestBody?: Wealthlane_CustomerService_Dtos_VendorDesignation_CreateUpdateVendorDesignationDto,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/customer/api/app/vendor-designation/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiCustomerApiAppVendorDesignation(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/customer/api/app/vendor-designation/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto OK
     * @throws ApiError
     */
    public static getApiCustomerApiAppVendorDesignation1(
        id: string,
    ): CancelablePromise<Wealthlane_CustomerService_Dtos_VendorDesignation_VendorDesignationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/customer/api/app/vendor-designation/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
